import AsyncPage from 'pages/AsyncPage'
import universal from 'react-universal-component'

const component = universal(() => import('./BookCairPaymentPage'))

class AsyncBookCairPaymentPage extends AsyncPage {
  nonav = true
  constructor() {
    super({
      title: 'navigation./book-cair',
      pageComponent: component,
      isChromeless: true,
    })
  }
}

export default new AsyncBookCairPaymentPage()
